import moment from 'moment/moment';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ListarDirectorios } from '../../../Service/Service.directorios';
import { TipoGenero } from '../../../Service/Service.genero';
import { RegistrarPaciente } from '../../../Service/Service.paciente';
import { ListarTipoDocumento } from '../../../Service/Service.tipoDocumento';
import { ListarTiposSeguros, ListarPlanesPorSeguro } from '../../../Service/Service.tipoSerguro';
import { SubirMedia } from '../../../Service/ServiceExternal';
import { GetTokenDecoded } from '../../../utils/storeUsuario';
import Alert from '../../Alert/Alert';
import SelectSearchble from '../../SelectSeachble/SelectSearchble';
import { ControllerListarSegurosClinica } from '../../../Service/Services.seguros';


const estadoCivil = [
  {
    value: 'SOLTERO',
    label: 'Soltero'
  },
  {
    value: 'CASADO',
    label: 'Casado'
  },
  {
    value: 'DIVORCIADO',
    label: 'Divorciado'
  },
  {
    value: 'VIUDO',
    label: 'Viudo'
  },
  {
    value: 'UNION LIBRE',
    label: 'Union libre'
  }
]
export default function PacienteCreacion({ handleClosePaciente, showPaciente, idclinica, pacienteEdit }) {
  const refdiv = useRef(null);
  const [statusCedula, setStatusCedula] = useState(true)
  const [tipoDocumentos, setTipoDocumentos] = useState([])
  const [tipoSeguros, setTipoSeguros] = useState([])
  const [tipogenero, setTipoGenero] = useState([])
  const [send, setSend] = useState(false)
  const [selectedOption, setSelectedOption] = useState([])
  const [whatsapp, setWhatsapp] = useState(false)
  const [seguros, setSeguros] = useState([])
  const [selectedSeguroOption, setSelectedSeguroOption] = useState(null);

  const [filteredSeguros, setFilteredSeguros] = useState([]);
  const [selectedTipoSeguro, setSelectedTipoSeguro] = useState("");

  const { register, watch, getValues, handleSubmit, formState: { errors }, setValue } = useForm({
    defaultValues: pacienteEdit || {}
  });
  const [alertType, setAlertType] = useState('')
  const [directorios, setDirectorios] = useState([])
  const [alertMessage, setAlertMessage] = useState('');
  const [planes, setPlanes] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleChange = async (selectedOption) => {
    await setSelectedOption(selectedOption);
  }

  const handleChangeSeguro = async (selectedSeguroOption, tipoSeguroParam = selectedTipoSeguro) => {
    if (!selectedSeguroOption || !selectedSeguroOption.value) return [];

    setSelectedSeguroOption(selectedSeguroOption);

    //const tipo = tipoSeguroParam ?? selectedTipoSeguro;
    const tipo = tipoSeguroParam || watch("tipo_seguro"); // 👈 usamos el valor actual del formulario
    if (String(tipo) === "3") {
      try {
        // CONFIG-PLANES-SEGURO-31: para SELECCIÓN nueva solo planes Activos; en
        // edición se incluye además el plan histórico del paciente aunque esté
        // inactivo (marcado visualmente) para no perder el dato existente.
        const responsePlanes = await ListarPlanesPorSeguro(selectedSeguroOption.value, {
          estado: "Activo",
          incluirPlanId: pacienteEdit?.plan_id,
        });
        if (responsePlanes && responsePlanes.success) {
          const opcionesPlan = responsePlanes.data.map(plan => ({
            value: plan.idplan || plan.id_plan,  // manejar ambos posibles nombres
            label: plan.estado === "Inactivo" ? `${plan.nombre} (Inactivo)` : plan.nombre
          }));
          setPlanes(opcionesPlan);
          console.log("📦 Planes cargados desde el backend:", opcionesPlan);
          return opcionesPlan;
        }
      } catch (error) {
        console.error("Error al cargar los planes:", error);
      }
    }

    setPlanes([]);
    return [];
  };


  const onSubmit = handleSubmit(async (data) => {

    let multimedia = []
    setSend(true)

    const processItem = async (item) => {
      if (data[`file-${item.value}`] && data[`file-${item.value}`][0]) {
        const url = await SubirMedia(data[`file-${item.value}`][0], null, null, GetTokenDecoded().idclinica, item.ruta);
        return { label: item.label, ruta: item.ruta, url: url };
      } else {
        return { label: item.label, ruta: item.ruta, url: item.url ? item.url : '' };
      }
    };

    if (pacienteEdit?.multimedia && pacienteEdit?.multimedia?.length > 0) {
      const promises = pacienteEdit.multimedia.map(async (item) => {
        return await processItem(item);
      });
      multimedia = await Promise.all(promises);
    }

    if (directorios && directorios.length > 0) {
      const promises = directorios.map(async (item) => {
        return await processItem(item);
      });
      const newMultimedia = await Promise.all(promises);
      multimedia = [...multimedia, ...newMultimedia];
    }

    data['edad'] = document.getElementById('edad').value
    data['multimedia'] = multimedia

    data['idclinica'] = GetTokenDecoded().idclinica
    data['seguro_id'] = selectedSeguroOption.value;


    Object.keys(data).forEach((key) => {
      if (data[key] != null && !isNaN(data[key]) && !["cedula", "celular", "telefono_casa", "telefono_oficina", "telefono_familiar"].includes(key)) {
        data[key] = parseInt(data[key]);
      }
    });

    data.whatsapp = whatsapp

    // validar que genero no se un objeto
    if (typeof data.genero === 'object') {
      data.genero = data.genero.value;
    }
    // tambien validar que tipo_documento no sea un objeto
    if (typeof data.tipo_documento === 'object') {
      data.tipo_documento = parseInt(data.tipo_documento.label);
    }
    if (selectedPlan) {
      data.plan_id = selectedPlan.value;
    } else {
      data.plan_id = null;
    }

    const resul = await RegistrarPaciente(data)

    if (resul?.success) {
      setAlertType('success')
      setAlertMessage(resul.message || 'Paciente creado correctamente')

      setSend(false)
      refdiv.current.scrollIntoView({ behavior: 'smooth' })

      setTimeout(() => {
        setAlertType('')
        setAlertMessage('')
        handleClosePaciente()
      }, 2500)

    } else {
      setAlertType('error')
      setAlertMessage(resul?.message || 'Error al guardar el paciente')

      setSend(false)
      refdiv.current.scrollIntoView({ behavior: 'smooth' })

      // NO cerrar modal cuando hay error
    }
  })

  const ChangeDocumento = (e) => {
    if (e.target.name === 'tipo_documento') {
      setStatusCedula(false)
    }
  }

  const getCodigoTipoDocumento = (idTipoDocumento) => {
    const encontrado = tipoDocumentos.find(
      (item) => String(item.idtipodocumento) === String(idTipoDocumento)
    );
    return encontrado?.codigo;
  }

  useEffect(() => {
    if (showPaciente) {
      (async () => {
        const data = await ListarTipoDocumento();
        if (data.success) setTipoDocumentos(data.data);

        const dataTipoSeguro = await ListarTiposSeguros(idclinica);
        if (dataTipoSeguro.success) setTipoSeguros(dataTipoSeguro.data);

        const dataGenero = await TipoGenero();
        if (dataGenero.success) setTipoGenero(dataGenero.data);

        const dataDirectorios = await ListarDirectorios(idclinica, null);
        if (dataDirectorios.success) setDirectorios(dataDirectorios.data);

        const dataSeguro = await ControllerListarSegurosClinica(idclinica);
        setSeguros(dataSeguro);

        if (pacienteEdit) {
          setWhatsapp(pacienteEdit.whatsapp);

          const filtered = dataSeguro.filter(
            (seguro) => seguro.idseguro === Number(pacienteEdit.seguro_id)
          );

          const seguroFormatteed = filtered.map((seg) => ({
            value: seg.idseguro,
            label: seg.nombre,
          }));

          setSelectedSeguroOption(seguroFormatteed[0] || null);
          setSelectedTipoSeguro(String(pacienteEdit.tipo_seguro));

          // ✅ Solo si es tipo SEGURO (id 3)
          if (String(pacienteEdit.tipo_seguro) === "3") {
            const opcionesPlan = await handleChangeSeguro({
              value: pacienteEdit.seguro_id,
              label: "",
            }, "3"); // <- pasamos tipo de seguro como string

            console.log("Datos del paciente editado:", pacienteEdit);

            // ✅ Comparación segura de strings
            const planActual = opcionesPlan.find(
              (p) => String(p.value) === String(pacienteEdit.plan_id)
            );

            if (planActual) {
              setSelectedPlan(planActual);
              console.log("✅ Plan cargado en edición:", planActual);
            } else {
              console.warn("⚠️ Plan guardado no encontrado:", pacienteEdit.id_plan);
            }
            console.log("Planes disponibles:", opcionesPlan);
            console.log("ID del plan guardado:", pacienteEdit.plan_id);

          }
        }
      })();
    }
  }, [showPaciente]);

  useEffect(() => {
    if (selectedPlan) {
      setValue("plan_id", String(selectedPlan.value)); // <== fuerza sincronización con el combo
    }
  }, [selectedPlan, setValue]);



  /*const handleChangeSeguro = selectedSeguroOption => {
    setSelectedSeguroOption(selectedSeguroOption);
  };*/

  useEffect(() => {
    if (selectedTipoSeguro) {
      const filtered = seguros.filter((seguro) => seguro.tipo_seguro_id === Number(selectedTipoSeguro));

      const seguroFormatteed = filtered.map((seg) => ({
        value: seg.idseguro,
        label: seg.nombre
      }));

      setFilteredSeguros(seguroFormatteed);

      // 💡 Solo después de cargar filteredSeguros, setea el seguro seleccionado
      if (pacienteEdit && pacienteEdit.seguro_id) {
        const seguroActual = seguroFormatteed.find(s => s.value === pacienteEdit.seguro_id);
        if (seguroActual) {
          setSelectedSeguroOption(seguroActual);
        }
      }

    } else {
      setFilteredSeguros([]);
    }
  }, [selectedTipoSeguro, seguros]);

  /*useEffect(() => {
    if (selectedTipoSeguro) {
      const filtered = seguros.filter((seguro) => seguro.tipo_seguro_id === Number(selectedTipoSeguro));

      const seguroFormatteed = filtered.map((seg) => ({
        value: seg.idseguro,
        label: seg.nombre
      }));

      setFilteredSeguros(seguroFormatteed);
    } else {
      setFilteredSeguros([]);
    }
  }, [selectedTipoSeguro, seguros]);*/

  return (
    <section>
      <Alert
        tipo_alert={alertType}
        type={alertType}
      />
      <Alert
        tipo_alert={alertType}
        type={alertType}
      />

      {alertMessage && (
        <div className={`alert ${alertType === 'success' ? 'alert-success' : 'alert-danger'}`}>
          {alertMessage}
        </div>
      )}
      <div className="row">
        <div
          ref={refdiv}
        />
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form id="form-clinica-create" onSubmit={onSubmit}>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Tipo de Documentoss</label>
                  <div className="col-sm-9">
                    <select className="form-select" name="tipo_documento" id="tipo_documento"
                      {...register("tipo_documento", {
                        required: true,
                        onChange: (e) => ChangeDocumento(e),
                      })}
                    >
                      <option value="">Seleccione</option>
                      {
                        tipoDocumentos.map((item) => (
                          <option
                            key={item.idtipodocumento}  // Agregamos una key única
                            value={parseInt(item.idtipodocumento)}
                            selected={pacienteEdit && item.idtipodocumento === pacienteEdit.tipo_documento}
                          >
                            {item.tipo}
                          </option>
                        ))
                      }

                    </select>
                    <Alert
                      tipo_alert="danger"
                      type={errors.tipo_documento?.type}
                    />
                  </div>
                </div>


                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Identificacion*</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" name='cedula' disabled={statusCedula}
                      {...register("cedula", {
                        required: true,
                        validate: (value) => {
                          const codigo = getCodigoTipoDocumento(getValues("tipo_documento"));
                          const soloDigitos = /^\d+$/.test(value || "");

                          if (codigo === 'C') {
                            return (soloDigitos && value.length === 10) || "La cédula debe tener exactamente 10 dígitos numéricos";
                          }
                          if (codigo === 'R') {
                            return (soloDigitos && value.length === 13) || "El RUC debe tener exactamente 13 dígitos numéricos";
                          }
                          // Pasaporte u otro tipo de documento: sin validacion de formato
                          return true;
                        }
                      })} />
                    <Alert
                      tipo_alert="danger"
                      type={errors.cedula?.type}
                      msj={errors.cedula?.message}
                    />

                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Nombres Completos*</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" {...register("nombres_completos", {
                      required: true,
                      minLength: 5,
                      maxLength: 160
                    })}
                      placeholder='Primero apellido y luego nombres'
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.nombre_completos?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Genero*</label>
                  <div className="col-sm-9">
                    <select className="form-select" name="genero" id="genero"
                      {...register("genero", {
                        required: true
                      })}
                    // value={pacienteEdit.genero.}
                    >
                      <option value="">Seleccione</option>
                      {
                        tipogenero.map((item, index) => (
                          <option value={item.tipo}
                            selected={pacienteEdit && item.tipo === pacienteEdit.genero ? true : false}
                          >{item.genero}</option>
                        ))
                      }
                    </select>
                    <Alert
                      tipo_alert="danger"
                      type={errors.genero?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Fecha de Nacimiento*</label>
                  <div className="col-sm-9">
                    <input type="date" className="form-control" {...register("fecha_nac", {
                      required: true
                    })}
                      onChange={(e) => {
                        if (e.target.value) {

                          let fecha = moment(e.target.value)
                          let hoy = moment()
                          let edad = hoy.diff(fecha, 'years')
                          document.getElementById('edad').value = edad
                        }
                      }}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.fceha_nac?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Edad*</label>
                  <div className="col-sm-9">
                    <input type="number" className="form-control" id='edad' disabled
                      {...register("edad", {
                        required: false
                      })} />
                    <Alert
                      tipo_alert="danger"
                      type={errors.edad?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Estado Civil</label>
                  <div className="col-sm-9">
                    <select className="form-select" name="estado_civil" id="estado_civil"
                      {...register("estado_civil", {
                        required: true
                      })}
                    >
                      <option value="">Seleccione</option>
                      {
                        estadoCivil.map((item, index) => (
                          <option value={item.label}
                            selected={pacienteEdit && item.label === pacienteEdit.estado_civil ? true : false}
                          >{item.label}</option>
                        ))
                      }
                    </select>
                    <Alert
                      tipo_alert="danger"
                      type={errors.estado_civil?.type}
                    />

                  </div>
                </div>
                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">N. Historia Clinica MSP</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" {...register("hc_msp", {
                      required: false
                    })} />
                    <Alert
                      tipo_alert="danger"
                      type={errors.hc_msp?.type}
                    />
                  </div>
                </div>


                <div className="row mb-4">
                  <label htmlFor="tipo_seguro" className="col-sm-3 col-form-label">Tipo de Seguro</label>
                  <div className="col-sm-9">
                    <select
                      className="form-select"
                      id="tipo_seguro"
                      {...register("tipo_seguro", { required: false })}
                      value={watch("tipo_seguro") || pacienteEdit?.tipo_seguro || ""}
                      onChange={(e) => {
                        setValue("tipo_seguro", e.target.value)
                        setSelectedTipoSeguro(e.target.value);

                      }}
                    >
                      <option value="">Seleccione</option>
                      {tipoSeguros.map((item) => (
                        <option key={item.idtiposeguro} value={item.idtiposeguro}>
                          {item.tipo}
                        </option>
                      ))}
                    </select>
                    <Alert tipo_alert="danger" type={errors.tipo_seguro?.type} />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="entidad" className="col-sm-3 col-form-label">Seguro / Entidad *</label>
                  <div className="col-sm-9">
                    <SelectSearchble
                      isDisabled={!selectedTipoSeguro}
                      listCompany={filteredSeguros}
                      handleChange={(option) => handleChangeSeguro(option, watch("tipo_seguro"))} // 👈 aseguras el tipo
                      selectedOption={selectedSeguroOption}
                      placeholder="Seleccione un tipo de seguro"
                    />

                  </div>
                </div>
                {selectedTipoSeguro === "3" && (
                  <div className="row mb-4">
                    <label htmlFor="plan" className="col-sm-3 col-form-label">Plan Asociado</label>
                    <div className="col-sm-9">
                      <select
                        className="form-select"
                        id="plan"
                        {...register("plan_id")}
                        value={String(watch("plan_id") || "")}
                        onChange={(e) => {
                          const selected = planes.find(p => String(p.value) === e.target.value);
                          setSelectedPlan(selected ?? null);
                        }}
                      >
                        <option value="">Seleccione un plan</option>
                        {planes.map((plan) => (
                          <option key={plan.value} value={String(plan.value)}>
                            {plan.label}
                          </option>
                        ))}
                      </select>


                    </div>
                  </div>
                )}

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Direccion*</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register("direccion", {
                        required: true,
                        minLength: 3,
                        maxLength: 100,
                      })} />
                    <Alert
                      tipo_alert="danger"
                      type={errors.direccion?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Lugar de Nacimiento*</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" {...register("lugar_nac", {
                      required: true,
                      minLength: 8,
                      maxLength: 160
                    })} />
                    <Alert
                      tipo_alert="danger"
                      type={errors.lugar_nac?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Email</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" name="email"
                      {...register("email", {
                        required: false,
                        minLength: 8,
                        maxLength: 160,
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Ingrese un correo electrónico válido (ej: nombre@dominio.com)"
                        }
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.email?.type}
                      msj={errors.email?.message}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Celular*</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" {...register("celular", {
                      required: true,
                      minLength: 9,
                      maxLength: 12,
                      type: 'number'
                    })} id="celular" />
                    <Alert
                      tipo_alert="danger"
                      type={errors.celular?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Tiene Whatsapp</label>
                  <div className="col-sm-9 d-flex text-center">
                    <div className="form-check form-switch form-switch-md">
                      <input type="checkbox" className="form-check-input"
                        id="customSwitch1"
                        onChange={(e) => setWhatsapp(e.target.checked)}
                        defaultChecked={pacienteEdit && pacienteEdit.whatsapp === true ? true : false}
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Telefono de casa</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register("telefono_casa", {
                        required: false,
                        minLength: 5,
                        maxLength: 100,
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.telefono_casa?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Telefono de oficina</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register("telefono_oficina", {
                        required: false,
                        minLength: 5,
                        maxLength: 100,
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.telefono_oficina?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Ocupacion</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" name="web" id="web"
                      {...register("ocupacion", {
                        required: false,
                        minLength: 5,
                        maxLength: 100,
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.ocupacion?.type}
                    />
                  </div>
                </div>


                <div className="row mb-4">
                  <label htmlFor="horizontal-email-input" className="col-sm-3 col-form-label">Lugar de trabajo</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register("lugar_trabajo", {
                        required: false,
                        minLength: 5,
                        maxLength: 160,
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.lugar_trabajo?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-email-input" className="col-sm-3 col-form-label">Nombre de familiar</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register("nombre_familiar", {
                        required: false,
                        minLength: 5,
                        maxLength: 160,
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.nombre_familiar?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-email-input" className="col-sm-3 col-form-label">Telefono familiar</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register("telefono_familiar", {
                        required: false,
                        minLength: 5,
                        maxLength: 100,
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.telefono_familiar?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-email-input" className="col-sm-3 col-form-label">Paciente proviene de:</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" name="tipo" id="tipo"
                      {...register("proviene", {
                        required: false,
                        minLength: 5,
                        maxLength: 100,
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.proviene?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-email-input" className="col-sm-3 col-form-label">Observacion:</label>
                  <div className="col-sm-9">
                    <textarea className="form-control"
                      {...register("observacion", {
                        required: false,
                        minLength: 5,
                        maxLength: 100,
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.observacion?.type}
                    />
                  </div>
                </div>

                {/* crear una seccion de multimedia dinamico por directorios donde el clinete selecione el directorio y se adjunte la imagen  */}
                <div className="row mb-4">
                  <label htmlFor="horizontal-email-input" className="col-sm-3 col-form-label">Multimedia</label>
                  <div className="col-sm-9">
                    <SelectSearchble
                      listCompany={directorios}
                      handleChange={handleChange}
                      selectedOption={selectedOption}
                      placeholder="Seleccione directorios"
                      isMulti={true}
                    />
                  </div>

                </div>
                {
                  selectedOption && selectedOption.length > 0 && selectedOption.map((item, index) => (

                    <div className="row mb-4">
                      <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">{item.label}</label>
                      <div className="col-sm-9">
                        <input type="file" className="form-control" name={`file-${item.value}`} accept='image/*'
                          {...register(`file-${item.value}`, {
                            required: false
                          })}
                        />
                      </div>
                    </div>
                  ))
                }

                {/* 
                  Si eciste  algun multimedia en la base de datos se debe mostrar para editar
                */}
                <div className="row mb-4">
                  {pacienteEdit && pacienteEdit.multimedia && pacienteEdit.multimedia.length > 0 &&
                    pacienteEdit.multimedia.map((item, index) => {
                      return (
                        item.url && (
                          <div key={index} className="col-sm-4">
                            <label
                              htmlFor="horizontal-firstname-input"
                              className="col-sm-3 col-form-label font-size-14"
                            >
                              {String(item.label)}
                            </label>
                            <div>
                              <img
                                src={`${item.url}`}
                                alt={item.label || "Multimedia"}
                                style={{ width: "100px", height: "100px" }}
                              />
                            </div>
                          </div>
                        )
                      );
                    })}

                </div>


                <div className="text-center">
                  {/* Botón Cancelar */}
                  <button
                    type="button"
                    className="btn btn-danger m-1"
                    onClick={handleClosePaciente} // Usa la función pasada como prop para cerrar el modal
                  >
                    Cancelar
                  </button>

                  {/* Botón Guardar */}
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={send} // Desactiva el botón mientras se está procesando
                  >
                    {send && (
                      <i className="bx bx-loader bx-spin font-size-16 align-middle me-2 btnSppinAjax"></i>
                    )}
                    {pacienteEdit ? 'Actualizar' : 'Crear'}
                  </button>
                </div>


              </form>


            </div>
          </div>
        </div>
      </div>


    </section>
  )
}
